/**
 * Utilitaires pour les appels
 * Fonctions pures <20 lignes chacune
 */

export function formatTimer(seconds) {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}
